import { FormFloatingCode } from '../codeHighlights/forms/FormFloatingCode';

const FloatingForm = () => {
  return (
    <>
      <h2>Floating Form</h2>
      <form noValidate={true} method="" id="bootstrapForm">
        <div className="form-floating mb-3">
          <input
            type="email"
            className="form-control"
            id="floatingInput"
            placeholder="name@example.com"
            required
          />
          <label htmlFor="floatingInput">Email address</label>
          <div className="invalid-feedback">
            You must agree before submitting.
          </div>
        </div>
        <div className="form-floating">
          <input
            type="password"
            className="form-control"
            id="floatingPassword"
            placeholder="Password"
            autoComplete="on"
          />
          <label htmlFor="floatingPassword">Password</label>
        </div>
      </form>

      <div className="mt-5">
        <FormFloatingCode />
      </div>
    </>
  );
};

export default FloatingForm;
